<template>
  <v-dialog  
    v-model="dialogVisible"
    overlay-color="#514585"
    overlay-opacity="0.98"
    content-class="dialog-full"
    >
    <v-card color="white" class="position-relative border-radius-2 pa-3">
      <v-row>
        <v-col>
          <h4 class="font-size-16">{{$t('challenge.details')}}</h4>
          <v-btn
            icon
            dark
            small
            color="white"
            class="close-btn"
            @click="closeDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <ul class="list-group">
        <li 
          class="list-group-item"
          v-for="(detail, i) in details"
          :key="i"
          >
          <div class="row ma-0 align-items-stretch">
            <div class="col-auto py-2 align-self-center">
              <v-img
                :src="require(`@/assets/img/icons/challenge-detail/${detail.icon}.svg`)"
              >
              </v-img>
            </div>
            <div class="col pl-0 py-2">
              <p class="mb-0 font-size-14" v-html="detail.text"></p>
            </div>
          </div>
        </li>
      </ul>
      <div class="px-3 mt-1">
        <v-row class="rewards-table_header ma-0">
          <v-col class="w-60">
            <span class="font-size-14">{{$t('challenge.rewards')}}</span>
          </v-col>
          <v-col>
            <span class="font-size-14">{{$t('challenge.correct_answers')}}</span>
          </v-col>
        </v-row>
      </div>
      <v-row class="ma-0">
        <v-col class="pt-0">
          <table class="rewards-table">
            <tr v-for="(reward, i) in rewards" :key="i">
              <td width="60%">
                
                <div class="row align-items-center">
                  <div class="col py-2 d-flex align-items-center">
                    <v-img
                      :src="require('@/assets/img/icons/icon-treasure-shadow.png')"
                      max-width="36"
                      class="d-inline-flex">
                    </v-img>
                    <div class="chip-awards mr-1">
                      <v-img
                        :src="require('@/assets/img/icons/xp-coin.png')"
                        max-width="24">
                      </v-img>
                      <span>{{reward.xp}}</span>
                    </div>
                    <span v-if="reward.coins">+</span>
                    <div class="chip-awards ml-1" v-if="reward.coins">
                      <v-img
                        :src="require('@/assets/img/icons/beecoins.png')"
                        max-width="24">
                      </v-img>
                      <span>{{reward.coins}}</span>
                    </div>
                  </div>
                </div>

            </td>
            <td>
              <div class="chip-awards px-2">
                <span>{{reward.answers}}</span>
              </div>
            </td>
          </tr>
        </table>
      </v-col>
    </v-row>
        
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PrizeChallenge',
  data() {
      return {
          dialogVisible: false,
          details: [
            { 
              text: 'Cada desafío incluye <b>4 preguntas</b> y tienes hasta <b>3 intentos</b> para responder.',
              icon: 'icon-quest' 
            },
            { 
              text: 'Desarrolla tu hábito lector, conviértete en un lector veloz y <b>sube tu posición en el ranking</b>.',
              icon: 'icon-rocket'
            },
            { 
              text: 'Solo se considera el <b>primer intento</b> de las respuestas para recibir los premios.',
              icon: 'icon-gift'
            },
          ],
          rewards: [
            {
              xp: 20,
              coins: 20,
              answers: 4
            },
            {
              xp: 15,
              coins: 15,
              answers: 3
            },
            {
              xp: 10,
              coins: 10,
              answers: 2
            },
            {
              xp: 5,
              coins: 5,
              answers: 1
            },
            {
              xp: 5,
              coins: 0,
              answers: 0
            },
          ]
      }
  },
  mounted() {
    this.$root.$on('openDialog', this.openDialog)
  },
  methods: {
    openDialog() {
      this.dialogVisible = true;
    },
    closeDialog() {
      this.dialogVisible = false;
    },
  },
}
</script>

<style lang="scss">
.list-group{
  margin: 0;
  padding: 0 16px!important;
  list-style: none;
}
.list-group-item{
  text-align: left;
  border-bottom: 1px solid #e6eaee;
  &:last-child{
    border-bottom: 0;
  }
}
.close-btn{
  position: absolute;
  right: 24px;
  left: inherit;
  top: 16px;
  z-index: 10;
  background: #514585;
}
.rewards-table{
  background: #fafafd;
  border: 1px solid #EEECF8;
  border-radius: 0 0 8px 8px;
  width: 100%;
  td{
    border-bottom: 1px solid #EEECF8;
  }
  tr:last-child td{
    border: 0;
  }
}
.chip-awards{
  background: #EEECF8;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  padding: 5px;
  img{
    margin-right: 1em;
  }
  span{
    font-size: 14px;
    font-weight: 600;
    vertical-align: middle;
  }
}
.rewards-table_header{
  background: #514585;
  border-radius: 8px 8px 0 0;
  color: white;
  font-weight: 600;
  line-height: 100%;
}
</style>